import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import Link from '@mui/material/Link';
import Container from 'atoms/Container';
import Logo from 'atoms/Icons/Logo';
import NextLink from 'atoms/NextLink';
import cn from 'classnames';
import React from 'react';
import data from 'static/content/footer';
import { getHomeLink } from 'utils/authUtils';

import s from './Footer.module.scss';
import Newsletter from './Newsletter';

const Footer = () => (
  <footer className={s.Footer}>
    <div className={s.Footer__main}>
      <Container narrowPadding maxWidth="1310px">
        <div className={s.Footer__columns}>
          <div className={s.Footer__column}>
            <NextLink href={getHomeLink()} key={'homepage'}>
              <a className={s.Footer__logo} aria-label="Homepage">
                <Logo fill="#fff" width="206" height="50" />
              </a>
            </NextLink>
            <div className={s.Footer__caption}>USREM Securities, LLC</div>
            <ul className={s.Footer__list}>
              <li className={s.Footer__listItem}>
                <NextLink href="https://www.google.com/maps/dir/157+13th+St,+Brooklyn,+NY+11215,+USA/">
                  <a target="_blank" className={s.Footer__iconLink}>
                    <LocationOnIcon />
                    <span>
                      {'750 Lexington Avenue'}
                      <br />
                      {'New York, NY 10022'}
                    </span>
                  </a>
                </NextLink>
              </li>
              <li className={s.Footer__listItem}>
                <NextLink href="mailto:contact@usremsecurities.com">
                  <a className={s.Footer__iconLink}>
                    <EmailIcon />
                    <span>{'contact@usremsecurities.com'}</span>
                  </a>
                </NextLink>
              </li>
              <li className={s.Footer__listItem}>
                <NextLink href="tel:+13322032293">
                  <a className={s.Footer__iconLink}>
                    <PhoneIcon />
                    <span>{'(332) 203-2293'}</span>
                  </a>
                </NextLink>
              </li>
            </ul>
          </div>
          {data.columns.map((column) => (
            <div className={s.Footer__column} key={column.title}>
              {column?.url ? (
                <NextLink href={column.url}>
                  <a
                    target={column?.newTab ? '_blank' : ''}
                    className={cn(s.Footer__title, s.Footer__link)}
                  >
                    {column.title}
                  </a>
                </NextLink>
              ) : (
                <strong className={s.Footer__title}>{column.title}</strong>
              )}

              <ul className={s.Footer__list}>
                {column.links.map(({ url, text, newTab, onClick }) => (
                  <li key={text} className={s.Footer__listItem}>
                    <NextLink href={url}>
                      <a
                        onClick={onClick}
                        target={newTab ? '_blank' : ''}
                        className={s.Footer__link}
                      >
                        {text}
                      </a>
                    </NextLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className={s.Footer__column}>
            <strong className={s.Footer__title}>{'Get our newsletter!'}</strong>
            <Newsletter />
            <strong className={s.Footer__title}>
              {'Follow us on '}
              <NextLink href="https://www.linkedin.com/company/usremsecurities/">
                <a className={s.Footer__socialLink} target="_blank" aria-label="LinkedIn">
                  <LinkedInIcon sx={{ fontSize: '30px' }} />
                </a>
              </NextLink>
            </strong>
          </div>
        </div>
      </Container>
    </div>
    <div id="legal" className={cn(s.Footer__legal)}>
      <Container narrowPadding maxWidth="1310px">
        <div dangerouslySetInnerHTML={{ __html: data.legal }}></div>
      </Container>
    </div>
    <div className={s.Footer__copyright}>
      <Container narrowPadding maxWidth="1310px">
        <div className={s.Footer__copyrightContainer}>
          <div className={s.Footer__copyrightInner}>
            <span>{new Date().getFullYear()} © USREM Securities, LLC</span>
            <ul className={s.Footer__copyrightLinks}>
              <li className={s.Footer__copyrightItem}>
                <NextLink passHref href="https://www.usremsecurities.com/terms-of-use">
                  <Link color="secondary" target="_blank">
                    {'Terms of use'}
                  </Link>
                </NextLink>
              </li>
              <li className={s.Footer__copyrightItem}>
                <NextLink passHref href="https://www.usremsecurities.com/privacy-policy">
                  <Link color="secondary" target="_blank">
                    {'Privacy policy'}
                  </Link>
                </NextLink>
              </li>
              <li className={s.Footer__copyrightItem}>
                <NextLink
                  passHref
                  href="https://res.usremsecurities.com/legal/Form CRS for Secondary Offerings.docx"
                >
                  <Link color="secondary">{'Form CRS'}</Link>
                </NextLink>
              </li>
              <li className={s.Footer__copyrightItem}>
                <NextLink
                  passHref
                  href="https://res.usremsecurities.com/legal/SRE_BCP_Summary_Disclosure_10252022.pdf"
                >
                  <Link color="secondary" target="_blank">
                    {'Business Continuity Plan'}
                  </Link>
                </NextLink>
              </li>
              <li className={s.Footer__copyrightItem}>
                <NextLink
                  passHref
                  href="https://res.usremsecurities.com/legal/SRE_CIP_Notice_Oct_202226292.pdf"
                >
                  <Link color="secondary" target="_blank">
                    {'CIP Notice'}
                  </Link>
                </NextLink>
              </li>
            </ul>
          </div>
          <NextLink passHref href="mailto:contact@usremsecurities.com">
            <Link className={s.Footer__contactUs} color="secondary" target="_blank">
              {'contact@usremsecurities.com'}
            </Link>
          </NextLink>
        </div>
      </Container>
    </div>
  </footer>
);

export default Footer;
